import apiClient from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _get = async (doId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/delivery-order/${doId}/load`,
    params: params,
  })

  return response?.data
}

export const get = (doId) => async (queryParam) => await _get(doId, queryParam)

export const _show = async (doId, loadId) => {
  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/delivery-order/${doId}/load/${loadId}`,
  })

  return response?.data
}

export const show = (doId) => async (loadId) => await _show(doId, loadId)

export const _store = async (doId, data) => {
  const response = await apiClient({
    baseURL,
    method: 'POST',
    url: `/delivery-order/${doId}/load`,
    data,
  })

  return response?.data
}

export const store = (doId) => async (data) => await _store(doId, data)

export const _update = async (doId, loadId, data) => {
  const response = await apiClient({
    baseURL,
    method: 'PATCH',
    url: `/delivery-order/${doId}/load/${loadId}`,
    data,
  })

  return response?.data
}

export const update = (doId) => async (loadId, data) => await _update(doId, loadId, data)

export const _deleteSingle = async (doId, loadId) => {
  const response = await apiClient({
    baseURL,
    method: 'DELETE',
    url: `/delivery-order/${doId}/load/${loadId}`,
  })

  return response?.data
}

export const deleteSingle = (doId) => async (loadId) => await _deleteSingle(doId, loadId)
